import { useMeContext } from '../api/me-provider.js';
import { BookingRoute } from './booking-route.js';
import { CoachBookRoute } from './coach-book-route.js';

/**
 * The Book tab. For an MPC coach it books on behalf of an athlete (ruled 16
 * October: anyone in the system, the coach's own family included); for
 * everyone else, the family's own booking as before.
 */
export function BookingTab() {
  const { state } = useMeContext();
  if (state.status === 'ready' && state.me.is_mpc_coach) return <CoachBookRoute />;
  return <BookingRoute />;
}
